import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-order',
  template: `
    <router-outlet></router-outlet>
  `,
  styles: []
})
export class WorkOrderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/system/work-order/work-order.component.ts